module.exports = __webpack_public_path__ + "static/media/navlogo.e58c4d40.png";